
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Quality = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M20.6,10a8.2,8.2,0,0,0-8.1-8.1A8.2,8.2,0,0,0,4.4,10a8.2,8.2,0,0,0,2.7,6v7.8l5.4-3.1,5.4,3.1V16A8.2,8.2,0,0,0,20.6,10ZM5.9,10a6.6,6.6,0,0,1,13.2,0A6.6,6.6,0,0,1,5.9,10ZM16.4,21.2,12.5,19,8.6,21.2V17a7.5,7.5,0,0,0,7.8,0Z"></path>
            <polygon points="16.4 8 15.3 7 11.6 11.4 9.7 9.5 8.6 10.5 11.7 13.6 16.4 8"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Quality.defaultProps = {
  title: 'Quality',
};

export default Quality;
